/** @jsxImportSource @emotion/react */
import * as React from 'react';
import CollapsibleGroup from '../layout/CollapsibleGroup';
import { css, SerializedStyles } from '@emotion/react';
import { AppDocItem } from './appDocItem';

const releaseNotes = css`
  max-height: none; 
  padding: 0 20px 25px;

  & ul {
    padding: 0;
    margin: 0;   /* optional—but usually you want this too */
    list-style-position: inside; /* optional */
  }
  `;

type Props = {
  docItem: AppDocItem;
  startCollapsed?: boolean;
  rootCss?: SerializedStyles;
};


/**
 * AppDocItemView: a component that renders an app document item in a collapsible, rich-tech friendly, readonly way.
 *
 * PureComponent: true
 * Connected to Redux: false
 */
export default class AppDocItemView extends React.PureComponent<Props> {
  public render = () => (
    <CollapsibleGroup header={this.props.docItem.title}
                      startCollapsed={this.props.startCollapsed}
                      rootCss={this.props.rootCss}>
      <div
        css={releaseNotes}
        dangerouslySetInnerHTML={{ __html: this.props.docItem.body }}
      />
    </CollapsibleGroup>
  );
}
